export default __webpack_public_path__ + "static/media/babyshop.63c66880.png";